import type { FPlusConfigurationTypeCheckingContext } from '@festina/configuration-general-types/configuration'
import { getFPlusLanguageServer } from '@festina-life/fplus'
import { useQuery } from '@tanstack/react-query'
import { useCallback, useMemo } from 'react'

import { useConfigurationLanguageServerInputInitializer } from '../fplus/useConfigurationLanguageServerInputInitializer'

type FetchLanguageServiceScopeProps = {
  expressionPath: string
}

export const useFetchLanguageServiceScope = ({
  expressionPath,
}: FetchLanguageServiceScopeProps) => {
  const languageServerInputProvider =
    useConfigurationLanguageServerInputInitializer()

  const languageServerInput = useMemo(
    () => languageServerInputProvider({ expressionPath }),
    [expressionPath, languageServerInputProvider],
  )

  const isEnabled = !!expressionPath

  const fetcher = useCallback(
    async () =>
      isEnabled
        ? await getFPlusLanguageServer().fetchScope(languageServerInput)
        : null,
    [languageServerInput, isEnabled],
  )

  const at = (
    languageServerInput.context as FPlusConfigurationTypeCheckingContext
  ).at

  return useQuery({
    queryKey: isEnabled
      ? [`languageServiceScope/${expressionPath}/${at ?? 'null'}`]
      : [],
    queryFn: fetcher,
  })
}
